import type { AxiosProgressEvent } from "axios";
import { z } from "zod";

export namespace MediaModels {
  export enum Use {
    IMAGE = "image",
    VIDEO = "video",
  }

  export enum UploadMethod {
    POST = "post",
    PUT = "put",
  }

  export const GetPresignedURLResponseSchema = z.object({
    uploadMethod: z.enum([UploadMethod.POST, UploadMethod.PUT]),
    mediaUrl: z.string(),
    uploadUrl: z.string(),
    fields: z.record(z.string()).optional(),
  });

  export type GetPresignedURLResponse = z.infer<typeof GetPresignedURLResponseSchema>;

  export type PutUploadRequest = {
    url: string;
    file: File;
    onUploadProgress: (progressEvent: AxiosProgressEvent) => void;
    abortController?: AbortController;
  };

  export type PostUploadRequest = PutUploadRequest & {
    fields: Record<string, string>;
  };
}
